import { render } from "./ModalLocation.vue?vue&type=template&id=6326213a&scoped=true"
import script from "./ModalLocation.vue?vue&type=script&lang=js"
export * from "./ModalLocation.vue?vue&type=script&lang=js"

import "./ModalLocation.vue?vue&type=style&index=0&id=6326213a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6326213a"]])

export default __exports__